import RelatedProducts from 'gatsby-theme-husky/src/components/RelatedProducts/RelatedProducts';
import './RelatedProductsOverride.scss';

export default RelatedProducts;
